import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const STORAGE_KEY = "mateo_lang_v2";

export default function LanguageModal() {
  const { i18n, t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const alreadyChosen = localStorage.getItem(STORAGE_KEY);
    if (!alreadyChosen) {
      const timer = setTimeout(() => setVisible(true), 400);
      return () => clearTimeout(timer);
    }
  }, []);

  function handlePick(lang: string) {
    i18n.changeLanguage(lang);
    localStorage.setItem(STORAGE_KEY, "1");
    setFadeOut(true);
    setTimeout(() => setVisible(false), 300);
  }

  if (!visible) return null;

  const languages = [
    { code: "pl", label: "Polski", sub: "Polish" },
    { code: "en", label: "English", sub: "English" },
    { code: "es", label: "Español", sub: "Spanish" },
  ];

  return (
    <div
      className={`fixed inset-0 z-[9999] flex items-center justify-center p-4 transition-opacity duration-300 ${
        fadeOut ? "opacity-0" : "opacity-100"
      }`}
    >
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
      <div className="relative bg-background-50 rounded-2xl w-full max-w-md p-8 shadow-2xl">
        <h2 className="font-heading text-xl font-semibold text-foreground-950 text-center mb-2">
          {t("lang_modal_title", "Choose your language")}
        </h2>
        <p className="text-foreground-600 text-sm text-center mb-8">
          {t("lang_modal_subtitle", "Select your preferred language to continue")}
        </p>

        <div className="flex flex-col gap-3">
          {languages.map((l) => (
            <button
              key={l.code}
              onClick={() => handlePick(l.code)}
              className="w-full flex items-center justify-between px-5 py-4 rounded-xl border border-background-200 hover:border-accent-300 hover:bg-accent-50/50 transition-all cursor-pointer group"
            >
              <div className="flex items-center gap-3">
                <span className="w-9 h-9 rounded-lg bg-background-100 flex items-center justify-center text-foreground-700 text-sm font-semibold group-hover:bg-accent-100 group-hover:text-accent-700 transition-colors">
                  {l.code.toUpperCase()}
                </span>
                <div className="text-left">
                  <p className="text-foreground-950 font-medium text-sm">{l.label}</p>
                  <p className="text-foreground-500 text-xs">{l.sub}</p>
                </div>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-accent-500 transition-colors"></i>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}